module.exports = __webpack_public_path__ + "media/images/woman-scheduling-6066b19df953b5962d53670747b62fea.png";